import { Checkbox } from '@material-ui/core'
import React from 'react'
import { Row } from 'react-table'

const CheckboxCell = ({ value }: Record<string, Row | boolean>) => {
    if (value === true || value === false) {
        return (
            <Checkbox
                style={{ padding: 0, margin: -2 }}
                disabled
                checked={value}
            />
        )
    }
    return <></>
}
export default CheckboxCell
